import { get_paywalls_state_config } from '../base';

export default get_paywalls_state_config({
    url: '/power_per_dollar',
    title: 'Power Per Dollar',
    template: require('./view.html'),
    is_missions_required: false,
});
